namespace $.$$ {
	
	$mol_style_define( $optimade_zero_user_page, {
		
		Pass_control: {
			flex: 'auto',
		},

		Check_email: {
			padding: $mol_gap.block,
			color: $mol_theme.special,
		},

		Foot: {
			justifyContent: 'flex-end',
		},
		
	} )
	
}
